import React from "react";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import RadialSeparators from "components/shared/RadialSeprators";
import "react-circular-progressbar/dist/styles.css";
import { Typography } from "@material-ui/core";

function BareIndicator({
  bareNumber,
  totalBares,
  currentTime,
  startTime,
  endTime,
  sepratorColor,
  size,
  ...rest
}) {
  const value = ((currentTime - startTime) / (endTime - startTime)) * 100;
  const colorValue = 150 + (bareNumber * 100) / totalBares;
  return (
    <CircularProgressbarWithChildren
      value={value}
      strokeWidth={5}
      styles={buildStyles({
        strokeLinecap: "butt",
        trailColor: "#d6d6d622",
        pathColor: `rgb(0,${colorValue},0)`,
        rotation: 0.5,
        path: {
          strokeDasharray: "0 1",
        },
        
      })}
    >
      <RadialSeparators
        count={4}
        style={{
          strokeLinecap: "butt",
          background: sepratorColor,
          width: "2px",
          // This needs to be equal to props.strokeWidth
          height: `${5}%`,
        }}
      />
      <Typography
        style={{
          marginTop: "10%",
          fontFamily: "bareIndicator",
          fontSize: size,
          color: "#005500",
          // textShadow: "2px 2px #ff0000",
          // webkitAnimation: "glow 1s ease-in-out infinite alternate",
          // mozAnimation: "glow 1s ease-in-out infinite alternate",
          // animation: "glow 1s ease-in-out infinite alternate",
          textShadow:
            "0 0 2px #fff, 0 0 4px #00aa00, 0 0 4px #00aa00, 0 0 4px #00aa00, 0 0 4px #00aa00, 0 0 4px #00aa00",
          // boxShadow: "inset 0 0 50px #fff,inset 20px 0 80px #f0f, inset -20px 0 80px #0ff, inset 20px 0 300px #f0f,  inset -20px 0 300px #0ff, 0 0 50px #fff,-10px 0 80px #f0f,10px 0 80px #0ff;",
        }}
      >
        {bareNumber}
      </Typography>
    </CircularProgressbarWithChildren>
  );
}

export default BareIndicator;
